import { useTranslation } from 'core/i18n';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';

export interface CustomAlarmActivateCommandComponentProps {
    onClick: VoidFunction;
}

export const CustomAlarmActivateCommandComponent: React.FC<CustomAlarmActivateCommandComponentProps> = ({
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <PocListItem data-testid="custom-alarm-activate-command" onClick={onClick}>
            <PocIcon slot="prefix" name="circle_on_off" family="outlined" />
            {t('settings.devices.custom-alarms.actions.activate')}
        </PocListItem>
    );
};
